import { DayPilot } from "daypilot-pro-angular";
import { Actor } from "../../model/actor";

export class NewActivityObject {
  start: DayPilot.Date;
  resourceId: string;
  type: string;
  duration: number;
  actor: Actor;

  constructor(
    start: DayPilot.Date,
    resourceId: string,
    type: string,
    duration: number,
    actor: Actor) {

    this.start = start;
    this.resourceId = resourceId;
    this.type = type;
    this.duration = duration;
    this.actor = actor;
    }
}
